export default __webpack_public_path__ + "e3e4368261bf09d26ac02d6fa5349354.svg";